import Pusher from 'pusher-js'
import supportApi from '@/api/support'
import localStorageService from '@/services/refresh.service'
import { SUPPORT_URL } from '@/components/support/config'

// Реальное время FAKT Support: Reverb сервиса поддержки говорит по протоколу Pusher, поэтому
// отдельный клиент pusher-js, а не CRM-сокет на socket.io. Каналы: private-support.branch.{id}
// (обращения филиала) и support.presence (присутствие поддержки). Токен для приватного канала
// берётся на каждую авторизацию: после refresh JWT подписка не ломается.

let client = null
// Имя канала → число подписчиков: канал покидаем, когда ушёл последний экран.
const subscribers = new Map()

function connect () {
  if (!client) {
    client = supportApi.config()
      .then(({ reverb }) => {
        const url = new URL(SUPPORT_URL)
        const secure = url.protocol === 'https:'
        const port = Number(url.port || (secure ? 443 : 80))

        return new Pusher(reverb.key, {
          wsHost: url.hostname,
          wsPort: port,
          wssPort: port,
          forceTLS: secure,
          enabledTransports: ['ws', 'wss'],
          // Обязателен для pusher-js 8, Reverb его не смотрит.
          cluster: 'mt1',
          disableStats: true,
          channelAuthorization: {
            transport: 'ajax',
            endpoint: `${SUPPORT_URL}/broadcasting/auth`,
            headersProvider: () => ({ Authorization: `Bearer ${localStorageService.getToken()}` }),
          },
        })
      })
      .catch((e) => {
        // Нет /api/config - следующая подписка попробует снова; экраны пока опрашивают API.
        client = null
        throw e
      })
  }

  return client
}

/**
 * Подписка на события канала: handlers - { 'message.created': fn, … }. Возвращает отписку,
 * её можно звать сразу, даже пока соединение ещё не поднялось.
 */
export function subscribe (channelName, handlers) {
  let stopped = false
  let bound = null

  connect()
    .then((pusher) => {
      if (stopped) return
      const channel = pusher.channel(channelName) || pusher.subscribe(channelName)
      subscribers.set(channelName, (subscribers.get(channelName) || 0) + 1)
      Object.entries(handlers).forEach(([event, fn]) => channel.bind(event, fn))
      bound = { pusher, channel }
    })
    .catch(() => {})

  return () => {
    stopped = true
    if (!bound) return
    Object.entries(handlers).forEach(([event, fn]) => bound.channel.unbind(event, fn))
    const left = (subscribers.get(channelName) || 1) - 1
    subscribers.set(channelName, left)
    if (left === 0) bound.pusher.unsubscribe(channelName)
  }
}

export function branchChannel (branchId) {
  return `private-support.branch.${branchId}`
}

export const PRESENCE_CHANNEL = 'support.presence'

/** Сокет сейчас жив: иначе экраны опрашивают API раз в 15 с (09-api, «Если сокет отвалился»). */
export async function isConnected () {
  try {
    return (await connect()).connection.state === 'connected'
  } catch {
    return false
  }
}
